
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5368',
  depVersions: {
  "data-privacy-request-ui": "static-1.5368",
  "data-fetching-client": "static-1.9522",
  "head-dlb": "static-1.4841",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7851",
  "hub-http-shared-msw-handlers": "static-1.9576",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11285",
  "I18n": "static-7.1583",
  "jasmine-runner": "static-1.6314",
  "privacy-center-public-service-types": "static-1.4631",
  "quartz": "static-1.6792",
  "react-dlb": "static-1.74",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5423",
  "UIComponents": "static-3.8232",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.82",
  "foundations-assets": "static-1.4683",
  "foundations-components": "static-1.7610",
  "foundations-components-test-utils": "static-1.5093",
  "foundations-theming": "static-1.4256",
  "hub-http": "static-1.6061",
  "quartz-config": "static-1.570",
  "quartz-core": "static-1.6011",
  "quick-fetch": "static-1.3781",
  "raven": "static-3.5725",
  "react": "static-7.182",
  "react-rhumb": "static-1.16495",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10989",
  "usage-tracker": "static-1.7179",
  "usage-tracker-anonymous": "static-1.5596",
  "usage-tracker-core": "static-1.7029",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3957",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3271",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3069",
  "quartz-webpack": "static-1.3016",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "HeadJS": "static-2.721",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2962",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3948",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "react-utils": "static-2.5217",
  "StyleGuideUI": "static-3.484",
  "jasmine": "static-4.4170",
  "rpc-client-utils": "static-1.4483",
  "HubStyle": "static-2.11593",
  "ui-addon-draggable": "static-3.4612",
  "cssUtils": "static-1.748",
  "hs-story-utils": "static-1.9270",
  "icons": "static-2.629",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1109",
  "bend-plugin-foundations-components": "static-1.3879",
  "floating-ui": "static-1.52",
  "foundations-theming-specialty": "static-1.1972",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1337",
  "ui-fonts": "static-1.547",
  "foundations-components-legacy": "static-1.635",
  "bend-plugin-foundations-theming": "static-1.2739",
  "foundations-theming-base": "static-1.3241",
  "stylex": "static-1.28",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.806",
  "hubspotter-http": "static-1.4521",
  "mobile-manifest-mixins": "static-1.496",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.467",
  "quartz-head": "static-1.457",
  "quartz-i18n": "static-1.467",
  "quartz-routing": "static-1.222",
  "quartz-test": "static-1.467",
  "quartz-tracking": "static-1.171",
  "usage-tracker-container": "static-1.7169",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2992",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.66",
  "sassPrefix": "static-1.152",
  "hubspotter-http-shared-msw-handlers": "static-1.9574"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5368",
  "data-fetching-client": "/data-fetching-client/static-1.9522",
  "head-dlb": "/head-dlb/static-1.4841",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7851",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9576",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11285",
  "I18n": "/I18n/static-7.1583",
  "jasmine-runner": "/jasmine-runner/static-1.6314",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4631",
  "quartz": "/quartz/static-1.6792",
  "react-dlb": "/react-dlb/static-1.74",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5423",
  "UIComponents": "/UIComponents/static-3.8232",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "foundations-assets": "/foundations-assets/static-1.4683",
  "foundations-components": "/foundations-components/static-1.7610",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5093",
  "foundations-theming": "/foundations-theming/static-1.4256",
  "hub-http": "/hub-http/static-1.6061",
  "quartz-config": "/quartz-config/static-1.570",
  "quartz-core": "/quartz-core/static-1.6011",
  "quick-fetch": "/quick-fetch/static-1.3781",
  "raven": "/raven/static-3.5725",
  "react": "/react/static-7.182",
  "react-rhumb": "/react-rhumb/static-1.16495",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10989",
  "usage-tracker": "/usage-tracker/static-1.7179",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5596",
  "usage-tracker-core": "/usage-tracker-core/static-1.7029",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3271",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3069",
  "quartz-webpack": "/quartz-webpack/static-1.3016",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "HeadJS": "/HeadJS/static-2.721",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2962",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3948",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "react-utils": "/react-utils/static-2.5217",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "jasmine": "/jasmine/static-4.4170",
  "rpc-client-utils": "/rpc-client-utils/static-1.4483",
  "HubStyle": "/HubStyle/static-2.11593",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4612",
  "cssUtils": "/cssUtils/static-1.748",
  "hs-story-utils": "/hs-story-utils/static-1.9270",
  "icons": "/icons/static-2.629",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1109",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3879",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1972",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1337",
  "ui-fonts": "/ui-fonts/static-1.547",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.635",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2739",
  "foundations-theming-base": "/foundations-theming-base/static-1.3241",
  "stylex": "/stylex/static-1.28",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.806",
  "hubspotter-http": "/hubspotter-http/static-1.4521",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.496",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.467",
  "quartz-head": "/quartz-head/static-1.457",
  "quartz-i18n": "/quartz-i18n/static-1.467",
  "quartz-routing": "/quartz-routing/static-1.222",
  "quartz-test": "/quartz-test/static-1.467",
  "quartz-tracking": "/quartz-tracking/static-1.171",
  "usage-tracker-container": "/usage-tracker-container/static-1.7169",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.66",
  "sassPrefix": "/sassPrefix/static-1.152",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9574"
}
};
